import { useContext, useEffect, useState, useMemo } from 'react';
import initDebug from 'debug';
import { GtmContext } from './GtmContext';
import { useBreakpoint } from '@next-common/breakpoint';
import axios from 'axios';
const debug = initDebug('canopy:GtmTags');
const error = initDebug('canopy:error:GtmHook');
const requiredKeys = ['event', 'location_alias', 'page_title'];
export const Gtm = () => {
    const [dataFromWs, setDataFromWs] = useState(null);
    const [wsCalled, setWsCalled] = useState(false);
    const [queue, setQueue] = useState([]);
    const { md } = useBreakpoint();
    const { wsParams, isEmbeddedInBuyerApp = false } = md;
    const isMobile = wsParams === null || wsParams === void 0 ? void 0 : wsParams.isMobile;
    const commenJSEventPayload = useMemo(() => {
        return {
            site_type: isMobile ? 'mobile' : 'desktop',
            gtm_env: !(Object.prototype.toString.call(global.process) === '[object process]') && window.gtmEnv ? window.gtmEnv : '',
            is_webview: isEmbeddedInBuyerApp,
        };
    }, [isMobile, isEmbeddedInBuyerApp]);
    const sendPageTag = (tagData) => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(tagData);
    };
    useEffect(() => {
        if (dataFromWs && queue.length > 0) {
            queue.map((eventPayload) => {
                if (eventPayload) {
                    sendPageTag(Object.assign(Object.assign(Object.assign({}, dataFromWs), commenJSEventPayload), eventPayload));
                }
                return null;
            });
            setQueue([]);
        }
    }, [dataFromWs, queue, commenJSEventPayload]);
    const checkMandatoryKeys = (_eventPayload) => {
        let hasRequiredKeys = false;
        requiredKeys.forEach((key) => {
            if (key in _eventPayload) {
                hasRequiredKeys = true;
            }
            else {
                hasRequiredKeys = false;
            }
        });
        return hasRequiredKeys;
    };
    const sendEvent = (eventPayload) => {
        if (checkMandatoryKeys(eventPayload)) {
            if (!wsCalled) {
                let url = '/restpublic/tech-web/partner';
                const params = new URLSearchParams(window.location.search);
                const trackingId = params.get('t');
                if (trackingId) {
                    url = url.concat('?trackingId=', trackingId);
                }
                axios
                    .get(url)
                    .then((res) => setDataFromWs(res.data))
                    .catch((err) => console.log(err));
                setWsCalled(true);
            }
            if (dataFromWs) {
                sendPageTag(Object.assign(Object.assign(Object.assign({}, dataFromWs), commenJSEventPayload), eventPayload));
            }
            else {
                //error with spread operator
                setQueue((prevQueue) => prevQueue.slice().concat([eventPayload]));
            }
        }
        else {
            error('Tag was not sent, a mandatory key is missing', eventPayload);
        }
    };
    return { sendEvent };
};
export const useGTM = (context = GtmContext) => useContext(context);
